import { defineComponent as _defineComponent } from 'vue'
import { Button, Icon, IconName, Picture, Tag, Typo } from '@travelata-libs/ui-kit';
  import { formatMoney, useViewport } from '@travelata-libs/utils';
  import { isTravelataOperatorId } from '@entities/operator';
  import { computed } from 'vue';
  import { PROVIDER_BENEFITS } from '../config';
  import { getProviderLogo } from '../lib/getProviderLogo';
  import type { ProviderOfferData } from '../model/types';

  interface ProviderItemProps {
    offer: ProviderOfferData;
  }

  interface ProviderItemEmits {
    (e: 'book'): void;
    (e: 'redirect', offer: ProviderOfferData): void;
    (e: 'checkout', offer: ProviderOfferData): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomProviderItem',
  props: {
    offer: null
  },
  emits: ["book", "redirect", "checkout"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'book'): void;
    (e: 'redirect', offer: ProviderOfferData): void;
    (e: 'checkout', offer: ProviderOfferData): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    offer: ProviderOfferData;
  }

  
  

  const { isMobile } = useViewport();

  const isExternal = computed<boolean>(() => !!props.offer.redirectUrl);
  const isTravelata = computed<boolean>(() => isTravelataOperatorId(props.offer.operatorId));
  const isLowestPrice = computed<boolean>(() => props.offer.isLowestPrice);

  const buttonAttributes = computed(() =>
    isExternal.value
      ? {
          appearance: 'tertiary',
          iconRight: IconName.ExternalLink,
        }
      : { appearance: 'primary' },
  );
  const buttonLabel = computed(() => (isExternal.value ? `Перейти на ${props.offer.name}` : 'Забронировать номер'));

  const handleButtonClick = (): void => {
    if (isExternal.value) {
      emit('redirect', props.offer);
      return;
    }
    if (isTravelata.value) {
      emit('book');
      return;
    }
    emit('checkout', props.offer);
  };

return { __sfc: true,props, emit, isMobile, isExternal, isTravelata, isLowestPrice, buttonAttributes, buttonLabel, handleButtonClick, Button, Icon, Picture, Tag, Typo, formatMoney, PROVIDER_BENEFITS, getProviderLogo }
}

})